
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexOIhghVUREFKWRh4mYZ2Yhjmec7MQ3_KGu5SIW9IpuV8Meta } from "/app/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93psdXSlGmkkjGVKbNUmBjdxwiiBRnil_B_zPSyEEQDk4Meta } from "/app/nuxt/pages/[slug].vue?macro=true";
import { default as indexHWE1HvAJARMLcTV7tozLDRsxPrLfJRnVTopU79Y0fQ8Meta } from "/app/nuxt/pages/insights/index.vue?macro=true";
import { default as indexmqHeI6w41sKrXH8f5o4_45rNbQP0Au2zi3STqabSy8_45ocMeta } from "/app/nuxt/pages/inclusions/index.vue?macro=true";
import { default as indexwKm0ZVvgQim9byutSSUoSR8bwBH9jVMDOIyqj1LR9qYMeta } from "/app/nuxt/pages/home-designs/index.vue?macro=true";
import { default as indexntqvp4IE3wSZVf7gDzwgq9efO1ls352xDAwNok6Ktr8Meta } from "/app/nuxt/pages/insights/[slug]/index.vue?macro=true";
import { default as indexVMeEjjec3MQmQlWO2o1JfQvIez9DQ2nGQvoOQUGAg84Meta } from "/app/nuxt/pages/home-designs/[slug]/index.vue?macro=true";
import { default as index_508bVHrakTXS66de4nUds2tSZIL_QYTLUZ83pUE3zUMeta } from "/app/nuxt/pages/house-land-packages/[slug]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/nuxt/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/nuxt/pages/[slug].vue")
  },
  {
    name: "insights",
    path: "/insights",
    meta: indexHWE1HvAJARMLcTV7tozLDRsxPrLfJRnVTopU79Y0fQ8Meta || {},
    component: () => import("/app/nuxt/pages/insights/index.vue")
  },
  {
    name: "inclusions",
    path: "/inclusions",
    meta: indexmqHeI6w41sKrXH8f5o4_45rNbQP0Au2zi3STqabSy8_45ocMeta || {},
    component: () => import("/app/nuxt/pages/inclusions/index.vue")
  },
  {
    name: "home-designs",
    path: "/home-designs",
    component: () => import("/app/nuxt/pages/home-designs/index.vue")
  },
  {
    name: "insights-slug",
    path: "/insights/:slug()",
    meta: indexntqvp4IE3wSZVf7gDzwgq9efO1ls352xDAwNok6Ktr8Meta || {},
    component: () => import("/app/nuxt/pages/insights/[slug]/index.vue")
  },
  {
    name: "home-designs-slug",
    path: "/home-designs/:slug()",
    meta: indexVMeEjjec3MQmQlWO2o1JfQvIez9DQ2nGQvoOQUGAg84Meta || {},
    component: () => import("/app/nuxt/pages/home-designs/[slug]/index.vue")
  },
  {
    name: "house-land-packages-slug",
    path: "/house-land-packages/:slug()",
    meta: index_508bVHrakTXS66de4nUds2tSZIL_QYTLUZ83pUE3zUMeta || {},
    component: () => import("/app/nuxt/pages/house-land-packages/[slug]/index.vue")
  }
]